export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').then(registration => {
        //console.log('SW registrado com sucesso: ', registration);
      }).catch(error => {
        //console.log('Erro ao registrar SW: ', error);
      });
    });
  }
}